import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutRightBlock = (props) => {
  const { cartItems } = props;
  let delay = 0,
    key = 1.1;

  return (
    <div className='checkout-right col-md-5'>
      <div className='checkout-inner-block'>
        {cartItems.map((c) => (
          <React.Fragment key={key++}>
            <div
              className='checkout-product-block'
              style={{ animationDelay: `${(delay += 0.07)}s` }}
            >
              <img src={c.product.imageUrl} alt='pro' />
              <div className='checkout-quantity'>{c.quantity}</div>
              <div className='checkout-product-details'>
                <div className='upper-text-checkout'>
                  <Link to={`/products/product/${c.product._id}`}>
                    <h4>{c.product.label}</h4>
                  </Link>
                  <h5>{c.product.size}</h5>
                  <h5>PKR {c.product.price}</h5>
                  {/* <h5>Qunatity: {c.quantity}</h5> */}
                </div>
              </div>

              <h6 className='checkout-total-price'>
                PKR {c.product.price * c.quantity}
              </h6>
            </div>
            {c.product.error && (
              <div
                style={{ animationDelay: `${(delay += 0.07)}s` }}
                className='alert alert-danger'
              >
                {c.product.error}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className='linee'></div>

      <div className='checkout-subtotal'>
        <h5>Sub total</h5>
        <h3>
          <span>PKR</span> {calculateTotal(cartItems)}
        </h3>
      </div>

      {/* <div className='checkout-subtotal'>
        <h5>Shipping</h5>
        <h3>
          <span>PKR</span> 0
        </h3>
      </div> */}

      <div className='linee'></div>

      <div className='checkout-total'>
        <h5>Total</h5>
        <h3>
          <span>PKR</span> {calculateTotal(cartItems)}
        </h3>
      </div>
    </div>
  );
};

const calculateTotal = (cartItems) => {
  let total = 0;
  //   const cartItems = this.cartItems;
  // const { cartItems } = this.props;

  for (const c of cartItems) total = total + c.product.price * c.quantity;

  return total;
};

export default CheckoutRightBlock;
